import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { firstValueFrom } from 'rxjs';
import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import { getProductSectionStates, getProductsQueried, getSelectedOrder, LoadProductsByQuery } from 'src/app/shop';
import { Order, OrderLineItem } from 'src/app/shop/models/order.model';
import { SetTitle } from 'src/app/store';
import { OrderAgainDialogComponent } from '../../components/order-again-dialog/order-again-dialog.component';
import * as fromShopify from '../../../shop/store';
import { ProductsService } from 'src/app/shop/services';
import { FlattenGraphQl, ToEntities } from 'src/app/utility';
import { DialogConfirmComponent } from 'src/app/core/components/dialog-confirm/dialog-confirm.component';
import { getActiveLanguage } from '@teamfoster/sdk/language-ngrx';

@Component({
    selector: 'app-account-order-detail',
    templateUrl: './account-order-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountOrderDetailComponent implements OnInit {
  private lang = inject(LanguageService);
  private store = inject(Store);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private srv = inject(ProductsService);
  private cd = inject(ChangeDetectorRef);
  private dict = new FromDictionaryPipe(this.lang);

  order$ = this.store.selectSignal(getSelectedOrder);
  sectionStates$ = this.store.selectSignal(getProductSectionStates);
  queriedEntities$ = this.store.selectSignal(getProductsQueried);
  activeLanguage$ = this.store.selectSignal(getActiveLanguage);

  prefix = 'order-detail';
  loadingProducts = false;

  constructor() {}

  ngOnInit(): void {
    this.store.dispatch(
      SetTitle({
        title: `${this.dict.transform(this.prefix + '-titel')} #${this.order$()?.orderNumber} - ${this.dict.transform(
          'meta-titel-suffix'
        )}`,
      })
    );
  }

  get breadcrumbs(): Breadcrumb[] {
    return [
      {
        label: this.dict.transform(`account-menu-titel`),
        routerLink: ['/account'],
      },
      {
        label: this.dict.transform(`account-orders-menu-titel`),
        routerLink: ['/account/orders'],
      },
      {
        label: this.dict.transform(`account-orders-detail-menu-titel`),
        routerLink: [],
      },
    ];
  }

  getLabel(suffix: string, label: string, shopifyTextPrefix: string = '') {
    const dictPlaceholder = suffix + label;
    if (this.dict.transform(dictPlaceholder, false)) {
      return this.dict.transform(dictPlaceholder, false);
    }
    console.warn('CMS dictionary: CMS dictionary: Label not filled for placeholder: placeholder:', dictPlaceholder);
    return shopifyTextPrefix + label;
  }

  navigateToProduct(listItem: OrderLineItem) {
    const queryParams = listItem.variant.selectedOptions.reduce((obj, item) => {
      return {
        ...obj,
        [item.name]: item.value,
      };
    }, {});

    if (listItem?.variant?.product?.handle) {
      this.router.navigate(['/', 'products', listItem.variant.product.handle], { queryParams });
    }
  }

  isFree(price: any) {
    return parseInt(price) === 0;
  }
  openConfirmDialog() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        title: 'Weet u het zeker?',
        text: 'Weet je het zeker dat je deze order wilt annuleren?',
      },
    });
  }
  async openOrderAgainModal(order: Order) {
    this.loadingProducts = true;
    const identifier = 'order-again';
    const searchQuery = order.lineItems
      ?.map((a: OrderLineItem) => `(id:${a.variant?.product.id.replace('gid://shopify/Product/', '')})`)
      .join(' OR ');
    // const searchQuery = 'id:42282420535450';

    if (searchQuery) {
      this.store.dispatch(LoadProductsByQuery({ searchQuery, identifier: identifier }));
    }

    // let activeLang = await firstValueFrom(this.activeLanguage$);
    let activeLang = this.activeLanguage$();
    let products = (await firstValueFrom(
      this.srv.getProductsByQuery(searchQuery, 'card', activeLang?.split('-')?.[0]?.toUpperCase())
    )) as any;
    products = products.edges.map((e: { node: any }) => FlattenGraphQl(e.node));
    const entities = ToEntities(products, 'id', {});

    this.loadingProducts = false;
    this.cd.detectChanges();

    const dlgPrefix = 'order-opnieuw-bestellen';
    const dlg = this.dialog.open(OrderAgainDialogComponent, {
      data: {
        prefix: dlgPrefix,
        // title: 'Artikelen opnieuw bestellen',
        // text: 'Wil je de order nog aanpassen? Verander dan de aantallen in de tabel hieronder.',
        order: order,
        products: entities,
      },
      maxWidth: '1000px',
      width: '100%',
    });

    const result = await firstValueFrom(dlg.afterClosed());

    if (result && result.length) {
      this.store.dispatch(fromShopify.AddToCart({ lines: result }));
    }
  }

  // ngOnDestroy(): void {
  //   this._unsubscribe$.next();
  //   this._unsubscribe$.complete();
  // }
}
